module.exports = __webpack_public_path__ + "static/media/Artboard1.aff22bd9.png";